module.exports = __webpack_public_path__ + "media/images/weather/999_night-37e9447038dfb2edf8863d1044648701.png";